import axios from 'axios';
import { helperGetApiHeaders, helperGetApiRoute, apiErrorHandler } from 'helpers/ApiHelper';

export const FETCH_FOOTER = 'FETCH_FOOTER';
export const FETCH_FOOTER_PROMOS = 'FETCH_FOOTER_PROMOS';

export function fetchFooter(deviceId) {
  const pageType = 'footer';
  const url = helperGetApiRoute(pageType);
  const headers = helperGetApiHeaders({ pathKey: pageType, deviceId });

  const request = axios.get(url, headers).catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_FOOTER,
    payload: request,
  };
}

export function fetchFooterPromos(accessToken, deviceId) {
  const pageType = 'globalPromos';
  const request = axios
    .get(
      helperGetApiRoute(pageType),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_FOOTER_PROMOS,
    payload: request,
  };
}
